const tabs = {
  root: {
    borderRadius: 10,
  },
  indicator: {
    height: 4,
  },
};

export default tabs;
